import { useEffect, useState} from "react";
import ApiServices from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import Loader from "../../utils/Loader";
import { showModal } from "../../redux/actions/ModalActions";
import ModalManager from "../../Modals/ModalManager";
import { Link, useParams } from "react-router-dom";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import * as qs from "qs"
import Trainer from "../../commonpage/Trainers";
import { handleItemsPerPageChange, handlePageChange } from "../../utils/PaginationUtilities";
export default function ViewTrainers({title}){
   const [selectedStudents,setSelectedStudents]=useState([])
   const dispatch=useDispatch()
   const loading=useSelector((state)=>state.loader.loading)
   const isOpen=useSelector((state)=>state.modal.isOpen)
   const [currentPage, setCurrentPage] = useState(0);
   const [itemsPerPage, setItemsPerPage] = useState(10);
   const [totalPages, setTotalPages] = useState(0);
   const [totalData, setTotalData] = useState(0);
   const {batchId}=useParams()
    const [peoples,setPeoples]=useState([])
    const fetchSchedules = async () => {
        try {
            dispatch(showLoader());
            const res = await ApiServices.apiRequest("getSingleBatch", { _id: batchId});
            if (res.data.success) {
                setTotalData(res.data.data.trainerId.length || 0);
                setTotalPages(Math.ceil(res.data.total / itemsPerPage));
                setPeoples(res.data.data)
            } else {
                toast.error(res.data.message);
            }
        } catch (err) {
            toast.error(err?.message || "Something went wrong");
        } finally {
            dispatch(hideLoader());
        }
    };

    useEffect(() => {
        if (!isOpen) {
            fetchSchedules();
        }
    }, [isOpen]);
  
    return(
        <>
            <div className="container">
                <div className="page-inner">
                {
                    loading && !isOpen? 
                        <Loader/>
                        :
                    <>
                        <div className="d-flex justify-content-between align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                            <div>
                                <h3 className="fw-bold mb-3">{title}</h3>
                            </div>
                        </div>
                        {/* <hr/> */}
                        <Trainer
                            peoples={peoples}
                            totalData={totalData}
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            handlePageChange={handlePageChange(setCurrentPage)}
                            handleItemsPerPageChange={handleItemsPerPageChange(setItemsPerPage, setCurrentPage)}
                        />

                    </>
                }
                </div>
            </div>
        </>
    )
}